<template>
  <FloatingBar
    v-if="hasAiAddon && isCurrentItemOwner"
    v-show="!isFloatingBarClosed && !isPlaying"
    :trial="isAiAddonTrial"
    :info_icon="showTranscriptionNoContentMessage && !isStillProcessing"
    @close="isFloatingBarClosed = true"
    @trial-click="onTrialClick"
  >
    <template #message>
      <span v-if="isStillProcessing" class="message">Zight AI is processing your video.</span>
      <span v-else-if="showTranscriptionNoContentMessage && !hasAudioStream" class="message">No voice detected</span>
      <span v-else-if="showTranscriptionNoContentMessage" class="message">This recording was too short or had no detectable speech</span>
      <span v-else class="message">Zight AI updated your content <a href="#" data-testid="floating-bar-ai-link" @click.prevent="requestGuide">below</a>.</span>
    </template>
  </FloatingBar>
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useStorage } from '@vueuse/core';
import { FloatingBar } from '@/storybook/floatingbar';
import { useSmartActionsStore } from '@/modules/viewer/store/useSmartActionsStore';
import { useTranscriptionStore } from '@/modules/viewer/store/useTranscriptionStore';
import { useViewerItemStore } from '@/modules/viewer/store/useViewerItemStore';
import { useVideoAi } from '@/modules/viewer/composables/useVideoAi';
import { useUser } from '@/modules/viewer/composables/useUser';
import { useGuideNavigationTrigger } from '@/modules/viewer/composables/useGuideNavigation';
import { computed } from 'vue';

const isFloatingBarClosed = useStorage('video-floating-bar-closed', false);
const smartActionsStore = useSmartActionsStore();
const transcriptionStore = useTranscriptionStore();
const viewerItemStore = useViewerItemStore();
const { isAiAddonTrial, hasAiAddon, hasTranscriptionEntitlement } = useVideoAi();
const { isCurrentItemOwner } = useUser();
const { requestGuide } = useGuideNavigationTrigger();

const { isProcessing } = storeToRefs(smartActionsStore);
const { isTranscriptionProcessing, isTranscriptionMissingContent } = storeToRefs(transcriptionStore);

const { currentVideoIsPlaying: isPlaying, isEditProcessing, hasAudioStream } = storeToRefs(viewerItemStore);

const isStillProcessing = computed(() => isProcessing.value || isTranscriptionProcessing.value || isEditProcessing.value);
const showTranscriptionNoContentMessage = computed(
  () => hasTranscriptionEntitlement.value && (hasAudioStream.value === false || isTranscriptionMissingContent.value)
);
const onTrialClick = () => {
  window.location.assign('/account/plans');
};
</script>
<style scoped>
.message a {
  @apply underline;
}
</style>
